import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FailTask, MarkTaskTimeout } from '@shared/actions/general.action';

@Injectable()
export class MyErrorHandler implements ErrorHandler {
  constructor(private store: Store) { }
  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        // this.store.dispatch(new StartLogout());
        return;
      }

      // currently the get header function is not work
      const taskId = error.headers.get("x-dmp-task-id");
      if (!taskId) return;
      switch (error.status) {
        case 504:
          this.store.dispatch(new MarkTaskTimeout(taskId));
          break;
        case 500:
        case 400:
          this.store.dispatch(new FailTask(taskId, error.error));
          break;
        // case 401:
        //   //this.store.dispatch([new FailTask(taskId, error), new SetLogoutPrompt(true, LogoutPromptType.REQUESTS_UNAUTHORIZED)]);
        //   this.store.dispatch([new FailTask(taskId, error), new StartLogout()]);
        //   break;
        default:
          break;
      }
    }
  }
}
